<a
  href="https://picflow.com/?utm_campaign=badge_free&utm_source=picflow&utm_medium=organic&utm_content={{ tenantId }}"
  target="_blank"
  class="picflow-badge"
>
  <img src="/assets/picflow-icon-exact.svg" alt="Picflow Logo" width="13" height="14" />
  <div class="text">Made with Picflow</div>
</a>
